<!-- Query ID -->
<div class="bpaas-content">
  <span>{{ "field.query-id" | translate }} : {{ queryId }}</span>
</div>

<!-- Search (可收合) -->
<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel
      header="{{ 'label.search' | translate }}"
      [toggleable]="true"
      [collapsed]="panelCollapsed"
      expandIcon="pi pi-angle-double-up"
      collapseIcon="pi pi-angle-double-down"
    >
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <!-- OU -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('ouId')" class="bpaas-required">
              {{ "field.ou" | translate }}
            </label>
            <p-autoComplete
              *ngIf="langChangeVisible"
              [suggestions]="ouSuggestions"
              [forceSelection]="true"
              [minLength]="2"
              [delay]="300"
              [showClear]="true"
              [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchOuSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')"
              dataKey="value"
              appendTo="body"
              formControlName="ouId"
              [inputId]="parseToId('ouId')"
              field="label"
            >
            </p-autoComplete>
            <div *ngIf="formControlInvalid('ouId')">
              <small class="p-error" *ngIf="formControl('ouId').errors?.['required']">
                {{ "message.validation.required" | translate }}
              </small>
            </div>
          </div>
          
          <!-- Item No -->
          <div class="col-12 md:col-3 lg:col-3">
            <label [for]="parseToId('itemNumber')" class="bpaas-required">
              {{ "field.item-number" | translate }}
            </label>
            <p-autoComplete
              *ngIf="langChangeVisible"
              [suggestions]="itemSuggestions"
              [forceSelection]="true"
              [minLength]="3"
              [delay]="300"
              [showClear]="true"
              [showEmptyMessage]="true"
              emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchItemSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteCode')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteCode')"
              dataKey="value"
              formControlName="itemNumber"
              [inputId]="parseToId('itemNumber')"
              field="label"
              appUppercase
              appTrimInput
            >
            </p-autoComplete>
            <div *ngIf="formControlInvalid('itemNumber')">
              <small class="p-error" *ngIf="formControl('itemNumber').errors?.['required']">
                {{ "message.validation.required" | translate }}
              </small>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="grid p-fluid justify-content-end bpaas-button-row">
          <div class="col-12 md:col-3 lg:col-2">
            <button
              type="button"
              pButton
              label="{{ 'button.reset' | translate }}"
              class="p-button-outlined mr-2"
              (click)="searchReset()"
              [id]="parseToId('btnReset')"
            ></button>
          </div>
          <div class="col-12 md:col-3 lg:col-2">
            <button
              type="button"
              pButton
              label="{{ 'button.query' | translate }}"
              (click)="query()"
              [id]="parseToId('btnQuery')"
            ></button>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
</div>

<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('item')">{{
            "field.item-number" | translate
          }}</label>
          <input
            type="text"
            pInputText
            [ngModel]="item"
            readonly="true"
            [id]="parseToId('item')"
          />
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('lockQty')">{{
            "field.lock-qty" | translate
          }}</label>
          <input
            type="text"
            pInputText
            [ngModel]="displayLockQty"
            readonly="true"
            [id]="parseToId('lockQty')"
          />
        </div>
      </div>
    </div>
  </p-panel>
</div>
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <!-- Detail Menu Bar -->
    <p-menubar
      *ngIf="detailMenubarVisible()"
      [model]="detailMenu"
      class="bpaas-detail-menubar"
      [id]="parseToId('detailMenu')"
    >
    </p-menubar>

    <!-- Table Tab Menu -->
    <p-tabMenu
      #detailTabMenuComponent
      [model]="detailTabs"
      styleClass="bpaas-table-tabmenu"
      (activeItemChange)="onDetailTabActiveItemChange($event)"
    >
    </p-tabMenu>

    <!-- Table Component -->
    <p-table
      #tableComponent
      [value]="detailDatas"
      styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [paginator]="true"
      [paginatorDropdownAppendTo]="'body'"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{
        'table.paginator'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      }}"
      [rowsPerPageOptions]="[10, 20, 50]"
      scrollHeight="75vh"
      [scrollable]="true"
      stateStorage="session"
      [stateKey]="tableStateStorageName"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()"
      (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)"
    >
      <!-- Table Header -->
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">

          <!-- Table Header Columns -->
          <th
            *ngFor="let column of columns"
            [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true"
            [style]="column.width ? 'width: ' + column.width + 'px' : ''"
            pResizableColumn
          >
            <label [class]="column.required ? 'bpaas-required' : ''">
              {{ column.header | translate }}
            </label>
            <p-sortIcon
              *ngIf="column.sortable"
              [field]="column.field"
            ></p-sortIcon>
          </th>
        </tr>

        <!-- Table Header Filter -->
        <tr *ngIf="tableFilterShow">
          <th *ngFor="let column of columns">
            <ng-container *ngIf="column.filter">
              <ng-container [ngSwitch]="column.filter.type">
                <p-columnFilter
                  [type]="column.filter.type"
                  [field]="
                    column.filter.field ? column.filter.field : column.field
                  "
                  [matchMode]="
                    column.filter.matchMode
                      ? column.filter.matchMode
                      : 'contains'
                  "
                  styleClass="w-full"
                  [showClearButton]="false"
                  [showButtons]="false"
                  [showMenu]="column.filter.type == 'dropdown' ? false : true"
                >
                  <!-- Table Header Dropdown Filter -->
                  <ng-template
                    *ngIf="column.filter.type == 'dropdown'"
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-dropdown
                      [ngModel]="value"
                      [options]="column.filter.options"
                      [optionLabel]="
                        column.filter.translateOptionFieldName
                          ? ('label' | translateFieldName : 'label')
                          : 'label'
                      "
                      optionValue="value"
                      placeholder="Any"
                      (onChange)="filter($event.value)"
                      [showClear]="true"
                      appendTo="body"
                    >
                    </p-dropdown>
                  </ng-template>

                  <!-- Table Header Date Filter -->
                  <ng-template
                    *ngIf="column.filter.type == 'date'"
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-calendar
                      #calendar
                      [ngModel]="value"
                      (onSelect)="filter(calendar.value)"
                      (keydown.enter)="filter(calendar.value)"
                      dateFormat="yy/mm/dd"
                      dataType="string"
                      appendTo="body"
                    >
                    </p-calendar>
                  </ng-template>
                </p-columnFilter>
              </ng-container>
            </ng-container>
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template
        pTemplate="body"
        let-rowData
        let-rowIndex="rowIndex"
        let-columns="columns"
      >
        <tr [id]="parseToId('rowData-' + rowIndex)">

          <!-- Table Body Data Display -->
          <td
            *ngFor="let column of columns"
            [class]="column.numberField ? 'bpaas-align-right' : ''"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)"
          >
            <ng-container
              *ngIf="column.translateDataValueField && langChangeVisible"
            >
              {{
                rowData[column.field]
                  | translateDataValue
                    : rowData
                    : column.translateDataValueField
              }}
            </ng-container>
            <ng-container
              *ngIf="column.translateArrayValue && langChangeVisible"
            >
              {{
                rowData[column.field]
                  | translateArrayValue
                    : column.translateArrayValue.datas
                    : column.translateArrayValue.valueField
                    : column.translateArrayValue.displayField
              }}
            </ng-container>
            <ng-container *ngIf="column.numberField">
              {{
                rowData[column.field] ??
                  (column.numberFieldDefaultZero ? 0 : "") | dynamicDecimal
              }}
            </ng-container>
            <ng-container *ngIf="column.dateField">
              {{
                rowData[column.field]
                  | date
                    : (column.dateFormat ? column.dateFormat : "yyyy/MM/dd")
                    : "GMT+8"
              }}
            </ng-container>
            <ng-container *ngIf="column.customField">
              <!-- 如果有需要條件判斷處理值的，自己寫在這段裡面 -->
            </ng-container>
            <ng-container
              *ngIf="
                !column.customField &&
                !column.translateDataValueField &&
                !column.translateArrayValue &&
                !column.numberField &&
                !column.dateField
              "
            >
              {{ rowData[column.field] }}
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length + (showActions ? 2 : 1)">
            {{ "table.no-records-found" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
<div class="bpaas-content">
  <p-panel header="{{ 'label.total' | translate }}">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('reservationQty')">{{
            "field.reservation-qty" | translate
          }}</label>
          <input
            type="text"
            pInputText
            [ngModel]="reservationQty | number : '1.0-0'"
            readonly="true"
            [id]="parseToId('reservationQty')"
          />
        </div>
        <div class="col-12 md:col-3 lg:col-3" *ngIf="showShareQty">
          <label [for]="parseToId('shareQty')">{{
            "field.share-qty" | translate
          }}</label>
          <input
            type="text"
            pInputText
            [ngModel]="shareQty | number : '1.0-0'"
            readonly="true"
            [id]="parseToId('shareQty')"
          />
        </div>
      </div>
    </div>
  </p-panel>
</div>
